module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-4032-8604987d9f0de253ca1d4690a0a0952a.jpg";